import Reveal from '@/components/base/Reveal';

const benefits = [
  {
    index: '01',
    kicker: 'Consistency',
    title: 'Same Rules, Every Trade',
    body: 'Entries never shift because of how confident the market feels that day — or how confident you do. The rules are fixed, so the outcome is repeatable.',
  },
  {
    index: '02',
    kicker: 'Clarity',
    title: 'Nothing to Guess',
    body: 'There is no price target to defend and no direction to argue for. The chart either meets the conditions or it does not — the market settles it, not opinion.',
  },
  {
    index: '03',
    kicker: 'Control',
    title: 'Emotion-Proof Decisions',
    body: 'A losing streak cannot pressure it into revenge trading, and a hot run cannot talk it into oversizing. It reacts to conditions, not to how the day feels.',
  },
];

function NoForecast() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start">
          <Reveal>
            <p className="text-[11px] font-data tracking-[0.24em] text-primary-600 mb-5">
              REACTIVE, NOT PREDICTIVE
            </p>
            <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[34px] leading-[1.08] sm:text-[42px] lg:text-[50px]">
              It Doesn’t Predict. It Responds.
            </h2>
          </Reveal>

          <Reveal delay={120}>
            <p className="text-[15px] md:text-base leading-relaxed text-foreground-600 lg:pt-3 max-w-[540px]">
              The system holds no view on where gold is heading — and neither do you have to.
              Instead of asking you to trust a forecast, it waits for a defined set of conditions
              and reacts to what the market is actually doing. That one decision takes the
              guessing — and the emotion — out of every single entry.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
          {benefits.map((item, idx) => (
            <Reveal key={item.index} delay={idx * 120}>
              <div className="h-full rounded-lg border border-background-300 bg-background-50 p-6 md:p-7 hover:border-primary-300 transition-colors duration-300">
                <div className="flex items-baseline gap-3">
                  <span className="font-data text-[11px] tracking-[0.2em] text-foreground-400">
                    {item.index}
                  </span>
                  <span className="font-data text-[11px] tracking-[0.2em] text-primary-600">
                    {item.kicker.toUpperCase()}
                  </span>
                </div>
                <h3 className="mt-4 font-heading font-bold tracking-tight text-foreground-950 text-[19px]">
                  {item.title}
                </h3>
                <p className="mt-3 text-[13px] leading-relaxed text-foreground-500">
                  {item.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NoForecast;